export default [
    {
        path: '/quotations/:id/show',
        name: 'QuotationShow',
        component: () => import(/* webpackChunkName: "main" */ '@/components/quotation-requests/OfferShow.vue')
    }
];
